import React from "react";
import './SelectProfileSkeleton.css';

export default function SelectProfileSkeleton() {
  return (
    <>
      <div className="border">
        <div className="bigText" />
        <div className="smallText" />
      </div>
      <div className="border">
        <div className="bigText" />
        <div className="smallText" />
      </div>
      <div className="border">
        <div className="bigText" />
        <div className="smallText" />
      </div>
      <div className="border">
        <div className="bigText" />
        <div className="smallText" />
      </div>
      <div className="border">
        <div className="bigText" />
        <div className="smallText" />
      </div>
      <div className="border">
        <div className="bigText" />
        <div className="smallText" />
      </div>
    </>
  );
}